export default __webpack_public_path__ + "static/media/594.eb58fa23.png";